<!-- Always-on overlay while verifying. Self-contained (not the global
     ngx-spinner) so the HTTP interceptor can't hide it between poll calls. -->
<div class="payment-verify-overlay" role="status" aria-live="polite">
    <span class="payment-verify-spinner" aria-hidden="true"></span>
    <span class="govuk-body payment-verify-overlay__text">Verifying payment…</span>
    <span class="govuk-body govuk-hint payment-verify-overlay__text" data-test="payment-verify-poll-count" *ngIf="pollCount > 0">
        Checking payment status... ({{ pollCount }}/{{ maxRetries }})
    </span>
</div>

<div class="govuk-width-container">

    <div class="row">
        <nav class="col-12 col-md-4" aria-label="Side navigation">
            <p class="govuk-body h-100"><app-menu></app-menu></p>
        </nav>
        <main class="govuk-main-wrapper col-12 col-md-8 pt-0" id="main-content" tabindex="-1">
            <div>
                <h1 class="govuk-heading-xl">Verifying payment</h1>
                <p class="govuk-body">Please wait while we verify the information from the payment provider.</p>
                <p class="govuk-body govuk-hint" data-test="payment-verify-poll-count" *ngIf="pollCount > 0">
                    Checking payment status... ({{ pollCount }}/{{ maxRetries }})
                </p>
            </div>
        </main>
    </div>

</div>